var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsapp-btn d-flex align-center justify-center cursor-pointer",on:{"click":_vm.goTo}},[_c('img',{attrs:{"width":_vm.isMd ? '24px' : '36px',"src":require('@/assets/images/icons/whatsapp.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }